import { Menu } from 'antd';

import styled from 'styled-components';

export const MenuWrapper = styled(Menu)`
  background: #243346 !important;

  & .ant-menu-sub {
    background: rgba(0, 0, 0, 0.2) !important;
  }

  & .ant-menu-item.ant-menu-item-selected {
    background: rgba(0, 0, 0, 0.2) !important;
    border-left: 2px solid #30b843;
  }

  & .site-layout-background {
    background: #243346 !important;
  }

  & .ant-menu-submenu-title {
    color: rgba(255, 255, 255, 0.65);
    background: #243346 !important;
  }
  & .ant-menu-submenu-arrow::before,
  .ant-menu-submenu-arrow::after {
    background: rgba(255, 255, 255, 0.65) !important;
  }
`;
